import { render, staticRenderFns } from "./StudyBackground.vue?vue&type=template&id=5643f3bc&"
import script from "./StudyBackground.vue?vue&type=script&lang=js&"
export * from "./StudyBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports